<template>
  <v-app class="app-root" v-if="userAuth">
    <link
      rel="stylesheet"
      href="https://w2.registrucentras.lt/savitarna/css/print.css"
      type="text/css"
      media="print"
    />
    <template v-if="userSutikimasNtr">
      <el-overlay-loading :loading="!loadedSavitarna" />
      <el-button v-if="isLocal" small tile @click.native="changeLang">{{
        $i18n.locale
      }}</el-button>
      <sav-toolbar class="app--toolbar" @loaded="loadedToolbar = true" />
      <v-main class="savitarna-main">
        <div class="savitarna-ntr-content-wrapper">
          <v-sheet class="d-flex">
            <div class="savitarna-ntr-content-left">
              <sav-left-menu @loaded="loadedMenu = true" />
            </div>
            <div class="savitarna-ntr-content-info" v-if="loadedSavitarna">
              <sav-breadcrumbs class="ma-0 pa-0" />
              <el-sistema-info savitarna />
              <router-view class="pa-0 mb-1" />
            </div>
          </v-sheet>
        </div>
        <!-- App Footer -->
        <sav-footer />
      </v-main>
      <!-- Go to top -->
      <app-fab />
    </template>
    <modal-savitarna-sutartis
      v-model="showSutartisModal"
      :loading="loading"
      ntrpaslaugos
      @confirmSutartis="confirmSutartis"
      @cancelSutartis="cancelSutartis"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import checkUser from '@/mixins/checkUser'
import SavToolbar from '@/components/layouts/savitarna/SavToolbar'
import SavLeftMenu from '@/components/layouts/savitarna/SavLeftMenu'
import SavBreadcrumbs from '@/components/layouts/savitarna/SavBreadcrumbs'
import SavFooter from '@/components/layouts/savitarna/SavFooter'
import AppFab from '@/components/layouts/turtas/AppFab'
import ModalSavitarnaSutartis from '@/components/modals/ModalSavitarnaSutartis'

export default {
  name: 'LayoutNtrPaslaugos',
  components: {
    SavToolbar,
    SavLeftMenu,
    SavBreadcrumbs,
    SavFooter,
    AppFab,
    ModalSavitarnaSutartis,
  },
  mixins: [checkUser],
  data() {
    return {
      userAuth: false,
      loadedToolbar: false,
      loadedMenu: false,
      loading: false,
      // showSutartisModal: false,
    }
  },
  computed: {
    ...mapGetters(['userID', 'savitarnaHomeUrl', 'userSutikimasNtr']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    loadedSavitarna() {
      return this.loadedToolbar && this.loadedMenu
    },
    showSutartisModal: {
      set(value) {
        //
      },
      get() {
        return !this.userSutikimasNtr
      },
    },
  },
  watch: {
    isAppIdle(val) {
      if (val) {
        if (!this.isLocal) {
          this.$store.dispatch('unlockPra')
          window._VMA.$emit('SAV_SESSION_ERROR')
        }
      }
    },
  },
  created() {
    this.setThemeColor()
    this.handleMetaData()
    this.checkLanguage()
    this.checkSavitarna()
    this.$store.dispatch('unlockPra')
  },
  methods: {
    changeLang() {
      if (this.$i18n.locale === 'lt') {
        this.$store.dispatch('setLanguage', { lang: 'en', i18n: this.$i18n })
      } else {
        this.$store.dispatch('setLanguage', { lang: 'lt', i18n: this.$i18n })
      }
    },
    checkSavitarna() {
      if (this.isLocal) {
        this.checkUser()
        return
      }
      this.checkUserSavitarna()
    },
    confirmSutartis() {
      // this.$store.dispatch('savitarnaSutartis', true)
      this.loading = true

      let data = {
        snau_id: this.userID,
        snau_sutikimas_su_salygomis: true,
        ntrpaslaugos: true,
      }
      this.$axios
        .post(`naudotojas/sutikimas`, data)
        .then(res => {
          this.$store.dispatch('userSutikimasNtr', true)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelSutartis() {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
      //window.history.go(-1)
    },
    handleMetaData() {
      const favicon = document.getElementById('favicon')
      favicon.href = `${process.env.VUE_APP_SAVITARNA_URL}faviconRC.ico`
      const title = document.getElementById('appTitle')
      title.innerHTML = 'VĮRC Savitarna'
    },
    checkLanguage() {
      const params = this.$route.query
      if (params.lang) {
        this.$store.dispatch('setLanguage', {
          lang: params.lang,
          i18n: this.$i18n,
        })
      }
    },
    setThemeColor() {
      this.$vuetify.theme.themes.light.primary = '#349800'
      this.$vuetify.theme.themes.light.primaryHover = '#276d01'
      this.$vuetify.theme.themes.light.lightPrimary = '#efffe7'
      this.$vuetify.theme.themes.light.anchor = '#000000'
      this.$vuetify.theme.themes.light.disabledText = '#888888'
    },
  },
}
</script>

<style lang="scss" scoped>
.app-root {
  background: #fff;
}
.savitarna-ntr-content-wrapper {
  width: 998px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 0 !important;
}
.savitarna-ntr-content-left {
  width: 221px;
  padding: 0;
}
.savitarna-ntr-content-info {
  min-height: calc(100vh - 120px - 200px);
  width: 745px;
  margin-left: 32px;
  padding: 0;
  background: none;
}
</style>
